import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import styled from 'styled-components'

import * as Validator from "../../../../../util/validation";
import Paragraph from "../../../../common/atom/text/paragraph";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import {ConstColor} from "../../../../../config/styles_const/styles_const";

interface IStateProps {
}

interface IProps extends IStateProps{
}

interface IState {
}

export class CustomerBlackListAddForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {

        const {handleSubmit, pristine, submitting, invalid} = this.props;

        return (
            <React.Fragment>

                <form
                    name="CustomerBlackListAddForm"
                    onSubmit={handleSubmit}
                >

                    <FormTextWrapper>
                        <Paragraph bold={true}>新規にブロックする企業ドメインを追加してください。</Paragraph>
                    </FormTextWrapper>

                    <FormFieldWrapper>
                        <Field
                            placeholder="例）libera-inc.com"
                            name={`domain`}
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.required, Validator.host, Validator.hostCount]}
                            require={true}
                        />
                    </FormFieldWrapper>
                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="CustomerBlackListAddForm-Submit"
                            type="submit"
                            widthSize={"200px"}
                            disabled={pristine || submitting || invalid}
                        >保存</BtnCorporateLarge>
                    </SubmitButtonWrapper>
                </form>

                <Line/>
            </React.Fragment>
        )

    }

}

const validate = (values: any) => {
    const errors: any = {};
    return errors;
};

export default reduxForm({
        form: 'CustomerBlackListAddForm',
        validate,
    }
)(CustomerBlackListAddForm);

const FormTextWrapper = styled.div`
    margin-bottom: 20px;
`;


const Line = styled.div`
    margin: 50px 0;
    border: solid 1px ${ConstColor.LightGray};
`;


// WEBPACK FOOTER //
// ./src/presentation/component/customer/black_list/edit/client_black_list_add_form.tsx